var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3797 4.23335L8.62634 3.8926L7.143 0.419814C7.03348 0.164672 6.78429 0 6.50693 0C6.22957 0 5.98028 0.164672 5.87146 0.419814L4.38812 3.8926L0.634199 4.23335C0.359019 4.25875 0.125998 4.44515 0.0398928 4.70793C-0.0457167 4.9712 0.0333456 5.25997 0.241467 5.4425L3.07868 7.93034L2.24213 11.6148C2.18092 11.8857 2.28608 12.1659 2.51086 12.3284C2.63169 12.4162 2.77364 12.46 2.91609 12.46C3.03851 12.46 3.16102 12.4275 3.27044 12.362L6.50693 10.4268L9.74283 12.362C9.98022 12.5038 10.2787 12.4909 10.503 12.3284C10.7278 12.1659 10.8329 11.8857 10.7717 11.6148L9.93518 7.93034L12.7724 5.4425C12.9804 5.25997 13.0596 4.9718 12.974 4.70793C12.8884 4.44465 12.6548 4.25825 12.3797 4.23335Z",
    fill: "#FFC947"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldStar);
export default __webpack_public_path__ + "static/media/gold-star.7948bdee610d4f20811a1d3f7f8ea65e.svg";
export { ForwardRef as ReactComponent };